export default __webpack_public_path__ + "static/media/mic-off-fill.80d73d29.svg";